import { apiDataSource } from "@/io/datasource/ApiDatasource.ts";
import { BaseApiDatasourceSpec } from "@/io/datasource/BaseApiDatasource.ts";
import { User, userSchema } from "@/models/UserModel.ts";

export class PatientRepository {
  constructor(private readonly datasource: BaseApiDatasourceSpec = apiDataSource) {}

  getMe = async () => this.datasource.get<User>(`/uploader/me/`, userSchema);
}
